/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { GetUsers200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { UserCreateModel } from '../models';
// @ts-ignore
import type { UserResponseModel } from '../models';
// @ts-ignore
import type { UserRoleResponseModel } from '../models';
// @ts-ignore
import type { UserSearchModel } from '../models';
// @ts-ignore
import type { UserUpdateModel } from '../models';
/**
 * KeycloakUserApi - axios parameter creator
 * @export
 */
export const KeycloakUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * ## Deletes user with id
         * @summary deletes User
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteUser', 'id', id)
            const localVarPath = `/api/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## Fetches assignable roles to the user
         * @summary returns assignable the roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignableRoles: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## Fetches user with id
         * @summary get user with id in the realm
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUser', 'id', id)
            const localVarPath = `/api/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get user attributes
         * @summary Get user attributes
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAttributes: async (id: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUserAttributes', 'id', id)
            const localVarPath = `/api/v1/users/{id}/attributes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## Fetches users according to query parameters
         * @summary get users in the realm
         * @param {UserSearchModel} userSearchModel 
         * @param {boolean} [allUsers] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: async (userSearchModel: UserSearchModel, allUsers?: boolean, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userSearchModel' is not null or undefined
            assertParamExists('getUsers', 'userSearchModel', userSearchModel)
            const localVarPath = `/api/v1/users/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (allUsers !== undefined) {
                localVarQueryParameter['allUsers'] = allUsers;
            }

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userSearchModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## Updates user with id
         * @summary Updates User
         * @param {string} id 
         * @param {UserUpdateModel} userUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser: async (id: string, userUpdateModel: UserUpdateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUser', 'id', id)
            // verify required parameter 'userUpdateModel' is not null or undefined
            assertParamExists('patchUser', 'userUpdateModel', userUpdateModel)
            const localVarPath = `/api/v1/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userUpdateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates user attributes
         * @summary Updates user attributes
         * @param {string} id 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserAttributes: async (id: string, requestBody: { [key: string]: any; }, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('patchUserAttributes', 'id', id)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('patchUserAttributes', 'requestBody', requestBody)
            const localVarPath = `/api/v1/users/{id}/attributes`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ## Creates user
         * @summary Creates a new user
         * @param {UserCreateModel} userCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUser: async (userCreateModel: UserCreateModel, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userCreateModel' is not null or undefined
            assertParamExists('postUser', 'userCreateModel', userCreateModel)
            const localVarPath = `/api/v1/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userCreateModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * KeycloakUserApi - functional programming interface
 * @export
 */
export const KeycloakUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = KeycloakUserApiAxiosParamCreator(configuration)
    return {
        /**
         * ## Deletes user with id
         * @summary deletes User
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ## Fetches assignable roles to the user
         * @summary returns assignable the roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAssignableRoles(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserRoleResponseModel>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAssignableRoles(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.getAssignableRoles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ## Fetches user with id
         * @summary get user with id in the realm
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUser(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponseModel>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUser(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.getUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get user attributes
         * @summary Get user attributes
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserAttributes(id: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserAttributes(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.getUserAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ## Fetches users according to query parameters
         * @summary get users in the realm
         * @param {UserSearchModel} userSearchModel 
         * @param {boolean} [allUsers] 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsers(userSearchModel: UserSearchModel, allUsers?: boolean, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUsers200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsers(userSearchModel, allUsers, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.getUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ## Updates user with id
         * @summary Updates User
         * @param {string} id 
         * @param {UserUpdateModel} userUpdateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUser(id: string, userUpdateModel: UserUpdateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUser(id, userUpdateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.patchUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates user attributes
         * @summary Updates user attributes
         * @param {string} id 
         * @param {{ [key: string]: any; }} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async patchUserAttributes(id: string, requestBody: { [key: string]: any; }, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.patchUserAttributes(id, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.patchUserAttributes']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ## Creates user
         * @summary Creates a new user
         * @param {UserCreateModel} userCreateModel 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postUser(userCreateModel: UserCreateModel, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postUser(userCreateModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['KeycloakUserApi.postUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * KeycloakUserApi - factory interface
 * @export
 */
export const KeycloakUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = KeycloakUserApiFp(configuration)
    return {
        /**
         * ## Deletes user with id
         * @summary deletes User
         * @param {KeycloakUserApiDeleteUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(requestParameters: KeycloakUserApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * ## Fetches assignable roles to the user
         * @summary returns assignable the roles
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAssignableRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRoleResponseModel>> {
            return localVarFp.getAssignableRoles(options).then((request) => request(axios, basePath));
        },
        /**
         * ## Fetches user with id
         * @summary get user with id in the realm
         * @param {KeycloakUserApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser(requestParameters: KeycloakUserApiGetUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponseModel> {
            return localVarFp.getUser(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * Get user attributes
         * @summary Get user attributes
         * @param {KeycloakUserApiGetUserAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserAttributes(requestParameters: KeycloakUserApiGetUserAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.getUserAttributes(requestParameters.id, options).then((request) => request(axios, basePath));
        },
        /**
         * ## Fetches users according to query parameters
         * @summary get users in the realm
         * @param {KeycloakUserApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers(requestParameters: KeycloakUserApiGetUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUsers200Response> {
            return localVarFp.getUsers(requestParameters.userSearchModel, requestParameters.allUsers, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * ## Updates user with id
         * @summary Updates User
         * @param {KeycloakUserApiPatchUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUser(requestParameters: KeycloakUserApiPatchUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchUser(requestParameters.id, requestParameters.userUpdateModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates user attributes
         * @summary Updates user attributes
         * @param {KeycloakUserApiPatchUserAttributesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        patchUserAttributes(requestParameters: KeycloakUserApiPatchUserAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.patchUserAttributes(requestParameters.id, requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * ## Creates user
         * @summary Creates a new user
         * @param {KeycloakUserApiPostUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postUser(requestParameters: KeycloakUserApiPostUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.postUser(requestParameters.userCreateModel, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * KeycloakUserApi - interface
 * @export
 * @interface KeycloakUserApi
 */
export interface KeycloakUserApiInterface {
    /**
     * ## Deletes user with id
     * @summary deletes User
     * @param {KeycloakUserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    deleteUser(requestParameters: KeycloakUserApiDeleteUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * ## Fetches assignable roles to the user
     * @summary returns assignable the roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    getAssignableRoles(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserRoleResponseModel>>;

    /**
     * ## Fetches user with id
     * @summary get user with id in the realm
     * @param {KeycloakUserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    getUser(requestParameters: KeycloakUserApiGetUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserResponseModel>;

    /**
     * Get user attributes
     * @summary Get user attributes
     * @param {KeycloakUserApiGetUserAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    getUserAttributes(requestParameters: KeycloakUserApiGetUserAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }>;

    /**
     * ## Fetches users according to query parameters
     * @summary get users in the realm
     * @param {KeycloakUserApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    getUsers(requestParameters: KeycloakUserApiGetUsersRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetUsers200Response>;

    /**
     * ## Updates user with id
     * @summary Updates User
     * @param {KeycloakUserApiPatchUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    patchUser(requestParameters: KeycloakUserApiPatchUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Updates user attributes
     * @summary Updates user attributes
     * @param {KeycloakUserApiPatchUserAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    patchUserAttributes(requestParameters: KeycloakUserApiPatchUserAttributesRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * ## Creates user
     * @summary Creates a new user
     * @param {KeycloakUserApiPostUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApiInterface
     */
    postUser(requestParameters: KeycloakUserApiPostUserRequest, options?: RawAxiosRequestConfig): AxiosPromise<string>;

}

/**
 * Request parameters for deleteUser operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiDeleteUserRequest
 */
export interface KeycloakUserApiDeleteUserRequest {
    /**
     * 
     * @type {string}
     * @memberof KeycloakUserApiDeleteUser
     */
    readonly id: string
}

/**
 * Request parameters for getUser operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiGetUserRequest
 */
export interface KeycloakUserApiGetUserRequest {
    /**
     * 
     * @type {string}
     * @memberof KeycloakUserApiGetUser
     */
    readonly id: string
}

/**
 * Request parameters for getUserAttributes operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiGetUserAttributesRequest
 */
export interface KeycloakUserApiGetUserAttributesRequest {
    /**
     * 
     * @type {string}
     * @memberof KeycloakUserApiGetUserAttributes
     */
    readonly id: string
}

/**
 * Request parameters for getUsers operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiGetUsersRequest
 */
export interface KeycloakUserApiGetUsersRequest {
    /**
     * 
     * @type {UserSearchModel}
     * @memberof KeycloakUserApiGetUsers
     */
    readonly userSearchModel: UserSearchModel

    /**
     * 
     * @type {boolean}
     * @memberof KeycloakUserApiGetUsers
     */
    readonly allUsers?: boolean

    /**
     * 
     * @type {number}
     * @memberof KeycloakUserApiGetUsers
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof KeycloakUserApiGetUsers
     */
    readonly pgSize?: number
}

/**
 * Request parameters for patchUser operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiPatchUserRequest
 */
export interface KeycloakUserApiPatchUserRequest {
    /**
     * 
     * @type {string}
     * @memberof KeycloakUserApiPatchUser
     */
    readonly id: string

    /**
     * 
     * @type {UserUpdateModel}
     * @memberof KeycloakUserApiPatchUser
     */
    readonly userUpdateModel: UserUpdateModel
}

/**
 * Request parameters for patchUserAttributes operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiPatchUserAttributesRequest
 */
export interface KeycloakUserApiPatchUserAttributesRequest {
    /**
     * 
     * @type {string}
     * @memberof KeycloakUserApiPatchUserAttributes
     */
    readonly id: string

    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof KeycloakUserApiPatchUserAttributes
     */
    readonly requestBody: { [key: string]: any; }
}

/**
 * Request parameters for postUser operation in KeycloakUserApi.
 * @export
 * @interface KeycloakUserApiPostUserRequest
 */
export interface KeycloakUserApiPostUserRequest {
    /**
     * 
     * @type {UserCreateModel}
     * @memberof KeycloakUserApiPostUser
     */
    readonly userCreateModel: UserCreateModel
}

/**
 * KeycloakUserApi - object-oriented interface
 * @export
 * @class KeycloakUserApi
 * @extends {BaseAPI}
 */
export class KeycloakUserApi extends BaseAPI implements KeycloakUserApiInterface {
    /**
     * ## Deletes user with id
     * @summary deletes User
     * @param {KeycloakUserApiDeleteUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public deleteUser(requestParameters: KeycloakUserApiDeleteUserRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).deleteUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## Fetches assignable roles to the user
     * @summary returns assignable the roles
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public getAssignableRoles(options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).getAssignableRoles(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## Fetches user with id
     * @summary get user with id in the realm
     * @param {KeycloakUserApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public getUser(requestParameters: KeycloakUserApiGetUserRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).getUser(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get user attributes
     * @summary Get user attributes
     * @param {KeycloakUserApiGetUserAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public getUserAttributes(requestParameters: KeycloakUserApiGetUserAttributesRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).getUserAttributes(requestParameters.id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## Fetches users according to query parameters
     * @summary get users in the realm
     * @param {KeycloakUserApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public getUsers(requestParameters: KeycloakUserApiGetUsersRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).getUsers(requestParameters.userSearchModel, requestParameters.allUsers, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## Updates user with id
     * @summary Updates User
     * @param {KeycloakUserApiPatchUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public patchUser(requestParameters: KeycloakUserApiPatchUserRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).patchUser(requestParameters.id, requestParameters.userUpdateModel, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates user attributes
     * @summary Updates user attributes
     * @param {KeycloakUserApiPatchUserAttributesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public patchUserAttributes(requestParameters: KeycloakUserApiPatchUserAttributesRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).patchUserAttributes(requestParameters.id, requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ## Creates user
     * @summary Creates a new user
     * @param {KeycloakUserApiPostUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof KeycloakUserApi
     */
    public postUser(requestParameters: KeycloakUserApiPostUserRequest, options?: RawAxiosRequestConfig) {
        return KeycloakUserApiFp(this.configuration).postUser(requestParameters.userCreateModel, options).then((request) => request(this.axios, this.basePath));
    }
}

